import axios from 'axios'
import { axiosClient, getCSRFToken } from 'www/utils'

let axiosCancelTokenSource

/**
 * @description Метод для проверки и подтверждения номера телефона при помощи смс кода для стаффов
 *
 * @param {object} options -
 * @param {string} options.phone - номер телефона (обязательный)
 * @param {string} options.code - смс код (обязательный)
 * @param {string} options.isJsonResponse- получить ответ в виде json (не обязательный)
 *
 * @returns { Promise } -
 */

function requestCheckCodeForStaff({ phone, code, isJsonResponse = true }) {
  const formData = new FormData()

  formData.append('phone', phone)
  formData.append('code', code)
  formData.append('json_response', String(isJsonResponse))

  axiosCancelTokenSource = axios.CancelToken.source()

  return axiosClient({
    method: 'POST',
    url: '/ajax/phone/confirm/',
    data: formData,
    headers: {
      'X-CSRFToken': getCSRFToken(),
      'Content-Type': 'multipart/form-data',
    },
    cancelToken: axiosCancelTokenSource.token,
  })
}

function cancelRequestCheckCodeForStaff() {
  if (axiosCancelTokenSource?.cancel) {
    axiosCancelTokenSource.cancel()
  }
}

export {
  requestCheckCodeForStaff,
  cancelRequestCheckCodeForStaff,
}
